export default __webpack_public_path__ + "static/media/aunty1.6e51323b.png";